// extracted by mini-css-extract-plugin
export var bounce = "_n6-1";
export var generatingText = "_n6-6";
export var lightning = "_n6-4";
export var popup = "_n6-5";
export var progressBar = "_n6-7";
export var progressFill = "_n6-8";
export var progressShimmer = "_n6-9";
export var progressText = "_n6-a";
export var shimmer = "_n6-3";
export var uploadIcon = "_n6-0";
export var uploadingText = "_n6-2";